// Interactive tutorial step definitions.
// Each step either explains a concept (text) or asks the player to perform
// a specific move from a prebuilt position.

import { emptyBoard, createInitialState } from "@/game/engine";

function withBoard(transform) {
  const base = createInitialState();
  const b = emptyBoard();
  transform(b);
  return { ...base, board: b };
}

export const TUTORIAL_STEPS = [
  {
    id: "intro",
    title: "Welcome to Tsoro",
    body: "Tsoro (also called Fuva or Imbwe) is a traditional Zimbabwean strategy game in the mancala family. Two players sow seeds around their own two rows and try to capture every seed on the opponent’s side.",
  },
  {
    id: "board",
    title: "The board",
    body: "There are four parallel rows of pits. The two rows nearest you belong to you. The row furthest from the centre is your outer row; the one closer to the centre is your inner row.",
  },
  {
    id: "setup",
    title: "Starting position",
    body: "Each outer-row pit begins with 2 counters. Both inner rows start empty. With 8 pits per row you begin with 32 counters in total.",
  },
  {
    id: "sowing",
    title: "Try sowing",
    body: "Tap the highlighted pit. You will pick up its 2 counters and drop them anticlockwise into the next pits on your own two rows.",
    interactive: true,
    setup: () => createInitialState(),
    requireMove: [3, 0],
    hint: "Tap the bottom-left pit on your side.",
  },
  {
    id: "relay",
    title: "Relay sowing",
    body: "When the final counter you sow lands in an already-occupied pit, you pick everything up from that pit (including the counter you just placed) and continue sowing. A single turn can contain several relays.",
  },
  {
    id: "capture",
    title: "Capturing",
    body: "Capture only happens when the final counter lands in your own previously-empty inner-row pit AND the opposite enemy inner pit has counters. You capture that inner pit, and the outer pit behind it too.",
    interactive: true,
    setup: () =>
      withBoard((b) => {
        b[3][7] = 1; // your singleton
        b[1][7] = 4; // enemy inner – will be captured
        b[0][7] = 3; // enemy outer – also captured
        b[1][0] = 2; // keep B alive so game continues
      }),
    requireMove: [3, 7],
    hint: "The highlighted pit will land in your inner row and capture column 8.",
  },
  {
    id: "singleton",
    title: "The singleton rule",
    body: "You may not move a pit with only 1 counter while you still have a pit with 2 or more. When only singletons remain, a singleton can move only into a pit that is empty.",
  },
  {
    id: "win",
    title: "Winning",
    body: "You win when every counter on the opponent’s side has been captured, or when they have no legal move. You lose when the same happens to you.",
  },
  {
    id: "ready",
    title: "You are ready",
    body: "Try a full game against the computer or a friend. You can come back to this tutorial any time.",
  },
];
